import type { ID } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'
import type { SaveProjectSagaPayload } from '@store/reducers/manager/actions'

import type { CrawledBlock } from '@/types'

export interface CrawledPageBlocks {
  nodeId: ID
  blocks: CrawledBlock[]
}

export interface CrawlImportProgress {
  done: number
  total: number
}

interface FinishCrawlImportPayload {
  pages: CrawledPageBlocks[]
  // What saveProjectSaga gets once the blocks are in.
  save: SaveProjectSagaPayload
}

export const CrawlImportActions = {
  // The blocks the crawler inferred go into the store, then the project is saved.
  finish: createAction<FinishCrawlImportPayload>('CRAWL_IMPORT_FINISH'),
  // Blocks parsed so far; null once they are all in.
  progress: createAction<CrawlImportProgress | null>('CRAWL_IMPORT_PROGRESS'),
}
